const React = require('react')
const { component } = require('../odo/odojs')
const inject = require('injectinto')
let ql = require('../odo/odoql')
ql = ql.use('store')
const navigation = require('../shared/navigation')
const route = require('odo-route')
const mergequeries = require('../odo/odoql/mergequeries')
const markdown = require('../shared/markdown')

route('/', p => ({ page: 'portfolio:homepage' }))

inject.bind(
  'page:portfolio:homepage',
  component({
    query: (params, hub) => {
      return mergequeries(
        {
          identity: ql.store('identity'),
          portfolio: ql.store('portfolio'),
          portfolio_image: ql.store('portfolio image')
        },
        navigation.query({
          selected: 'homepage'
        })
      )
    },
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      const { logo, splash } = state.portfolio_image ?? {}
      return (
        <div className='page--wrapper'>
          {navigation(
            state,
            {
              selected: 'home'
            },
            hub
          )}
          <hr />
          <div className='portfolio-homepage'>
            {logo ? (
              <div
                className='logo'
                style={{
                  backgroundImage: `url(${logo.originalUrl})`,
                  backgroundPosition: `${logo.placement}`
                }}
              />
            ) : null}
            {splash ? <div className='splash' style={{ backgroundImage: `url(${splash.originalUrl})` }} /> : null}
          </div>
          <div className='portfolio-homepage-contextual-help'>
            {markdown(state.portfolio.contextualhelp?.home ?? '')}
          </div>
        </div>
      )
    }
  })
)
